module.exports = __webpack_public_path__ + "static/login_logo-fa85f8384d0782beef8f4826c24ba070.png";